import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-6" }
const _hoisted_13 = { class: "col-span-6" }
const _hoisted_14 = { class: "pl-5 list-disc" }
const _hoisted_15 = { class: "text-gray-500 text-sm mt-1.5" }
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = { class: "col-span-6" }
const _hoisted_18 = { class: "col-span-6" }
const _hoisted_19 = { class: "col-span-6" }
const _hoisted_20 = { class: "col-span-6" }
const _hoisted_21 = { class: "col-span-6" }
const _hoisted_22 = { class: "col-span-6" }
const _hoisted_23 = { class: "col-span-12" }
const _hoisted_24 = {
  key: 0,
  class: "col-span-12"
}

import AdminLayout from '@/layouts/AdminLayout.vue';
import PatientLayout from '../components/PatientLayout.vue';

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';
import PageLoader from '@/components/PageLoader.vue';
import Patient from '@/classes/Patient';

import { useRoute } from 'vue-router';
import { ref, computed, onMounted } from 'vue';
import { formatter } from '@/helpers/NumberHelper'
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route = useRoute();
const bookingId = ref(route.params.bookingId);
const patientId = ref(route.params.id);
const loader      = ref(true)
const showError   = ref(false);
const errorMsg    = ref(false);
const form        = ref({
    first_name            : null,
    middle_name          : null,
    last_name            : null,
    patient_id           : null,
    hospital_no          : null,
    email_address        : null,
    booking_start_time   : null,
    booking_end_time     : null,
    booking_date         : null,
    medical_questionnaire: null,
    package_name         : null,
    riders               : null,
    package_fee          : 0,
    misc_fee             : 0,
    // patient_type         : null,
    branch_name          : null,
    booking_type         : null,
    booking_status       : null,
    remarks              : null
})

const canViewMedicalRecords = computed(() => {
    if(
        window.$hasPermission('view-corporate-patient-medical-records') ||
        window.$hasPermission('view-web-booking-medical-records') ||
        window.$hasPermission('view-contact-center-booking-medical-records') ||
        window.$hasPermission('view-patient-medical-records') ||
        window.$hasPermission('view-medical-records-in-offline')
    ) {
        return true;
    }

    return false;
});

const appointment = ref(null)


const riders = computed(() => {
    let items = '';

    if(typeof appointment.value?.other_charges_details == 'string') {
        return appointment.value?.other_charges_details;
    }

    if(appointment.value?.other_charges_details?.length > 0) {
        appointment.value?.other_charges_details[0]?.trans_line.forEach(element => {
            items += element.items ? element.items.description + ', ' : '';
        });
    }
    return items;
});


const miscFee = computed(() => {
    if(appointment.value?.package_details?.length > 0){
        
        return appointment.value?.package_details[0]?.trans_line?.reduce((a, b) => a + b.price, 0)
    }
    
    return 0;

});

const discountAmount = computed(() => {
    if(appointment.value?.package_details?.length > 0){
        
        return appointment.value?.discount_amount;
    }
    
    return 0;

});

const totalFee = computed(() => {
    if(appointment.value?.package_details?.length > 0){
        
        return appointment.value?.total_fee;
    }
    
    return 0;

});

onMounted(() => {
    loader.value = true;
    setTimeout(() => {
        Patient.showSingleBooking(bookingId.value).then((response) => {
            loader.value = false;
            const result = response.data.response;
            appointment.value = result;
            const patient = result?.patient;
            // const packageDetails = result?.package_details[0];

            form.value.first_name     = patient?.first_name
            form.value.middle_name   = patient?.middle_name
            form.value.last_name     = patient?.last_name
            form.value.patient_id    = patient?.patient_id
            form.value.hospital_no   = patient?.hospital_no
            form.value.email_address = patient?.email_address

            form.value.booking_start_time = result?.booking_start_time ? new Date(new Date(result.booking_start_time).getTime() + new Date().getTimezoneOffset() * 60000).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : '';
            form.value.booking_end_time = result?.booking_end_time ? new Date(new Date(result.booking_end_time).getTime() + new Date().getTimezoneOffset() * 60000).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : '';
            form.value.booking_date       = format(new Date(result?.booking_date), 'MMM dd, yyy')

            form.value.medical_questionnaire = result?.medical_questionnaire ? 'Yes' : 'No'
            form.value.package_name          = result?.package_name
            form.value.package_fee           = formatter.format(result?.total_fee)

            if(result?.other_charges_details.length > 0) {
                result?.other_charges_details.forEach(otherCharges => {
                    otherCharges.trans_line.forEach(trans_line => {
                        const totalAmount = trans_line.price * trans_line.qty;
                        form.value.misc_fee = formatter.format(totalAmount)
                    });
                });
            }

            form.value.branch_name    = result?.branch_name
            // form.value.patient_type   = result?.booking_type
            form.value.booking_type   = result?.booking_type
            form.value.booking_status = result?.status
            form.value.remarks        = '' //@TODO: doctors remarks
        })
        .catch((err) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = err.response.data.message;
        })
    }, 1000);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Booking",
    "show-back": "",
    backUrl: `/accounts/patients/bookings/${patientId.value}`
  }, {
    default: _withCtx(() => [
      _createVNode(PatientLayout, { "patient-id": patientId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FormSection, null, {
              title: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode(" Booking Information ", -1)
              ]))]),
              description: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode(" Relevant data and other details ", -1)
              ]))]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(TextInput, {
                    modelValue: form.value.first_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
                    id: "first_name",
                    name: "first_name",
                    disabled: "",
                    label: "First Name",
                    placeholder: "First Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TextInput, {
                    modelValue: form.value.middle_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.middle_name) = $event)),
                    id: "middle_name",
                    name: "middle_name",
                    disabled: "",
                    label: "Middle Name",
                    placeholder: "Middle Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(TextInput, {
                    modelValue: form.value.last_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.last_name) = $event)),
                    id: "last_name",
                    name: "last_name",
                    disabled: "",
                    label: "Last Name",
                    placeholder: "Last Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(TextInput, {
                    modelValue: form.value.patient_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.patient_id) = $event)),
                    id: "patient_id",
                    name: "patient_id",
                    disabled: "",
                    label: "Patient ID",
                    placeholder: "Patient ID"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(TextInput, {
                    modelValue: form.value.hospital_no,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.hospital_no) = $event)),
                    id: "hospital_no",
                    name: "hospital_no",
                    disabled: "",
                    label: "Hospital ID",
                    placeholder: "Hospital ID"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(TextInput, {
                    modelValue: form.value.email_address,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.email_address) = $event)),
                    id: "email_address",
                    name: "email_address",
                    disabled: "",
                    label: "Email Address",
                    placeholder: "Email Address"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(TextInput, {
                    modelValue: form.value.booking_start_time,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.booking_start_time) = $event)),
                    id: "booking_start_time",
                    name: "booking_start_time",
                    disabled: "",
                    label: "Start Time",
                    placeholder: "Start Time"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(TextInput, {
                    modelValue: form.value.booking_end_time,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.booking_end_time) = $event)),
                    id: "booking_end_time",
                    name: "booking_end_time",
                    disabled: "",
                    label: "End Time",
                    placeholder: "End Time"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(TextInput, {
                    modelValue: form.value.booking_date,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.booking_date) = $event)),
                    id: "booking_date",
                    name: "booking_date",
                    disabled: "",
                    label: "Booking Date",
                    placeholder: "Booking Date"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(TextInput, {
                    modelValue: form.value.medical_questionnaire,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.medical_questionnaire) = $event)),
                    id: "medical_questionnaire",
                    name: "medical_questionnaire",
                    disabled: "",
                    label: "Medical Questionnaire Filled",
                    placeholder: "Medical Questionnaire Filled"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(TextInput, {
                    modelValue: form.value.package_name,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.package_name) = $event)),
                    id: "package_name",
                    name: "package_name",
                    disabled: "",
                    label: "Package",
                    placeholder: "Package"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[21] || (_cache[21] = _createElementVNode("p", { class: "block text-sm text-gray-900" }, "Rider/s", -1)),
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", _hoisted_15, _toDisplayString(riders.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(TextInput, {
                    modelValue: form.value.package_fee,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.package_fee) = $event)),
                    id: "package_fee",
                    name: "package_fee",
                    disabled: "",
                    "add-on-left": "",
                    "add-on-text": "₱",
                    label: "Package Fee",
                    placeholder: "Package Fee"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(TextInput, {
                    modelValue: miscFee.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((miscFee).value = $event)),
                    id: "misc_fee",
                    name: "misc_fee",
                    disabled: "",
                    "add-on-left": "",
                    "add-on-text": "₱",
                    label: "Miscellaneous Fee",
                    placeholder: "Miscellaneous Fee"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(TextInput, {
                    modelValue: discountAmount.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((discountAmount).value = $event)),
                    id: "misc_fee",
                    name: "misc_fee",
                    disabled: "",
                    "add-on-left": "",
                    "add-on-text": "₱",
                    label: "Discount Amount",
                    placeholder: "Discount Amount"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(TextInput, {
                    modelValue: totalFee.value,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((totalFee).value = $event)),
                    id: "total_fee",
                    name: "total_fee",
                    disabled: "",
                    "add-on-left": "",
                    "add-on-text": "₱",
                    label: "Total Fee",
                    placeholder: "Total Fee"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(TextInput, {
                    modelValue: form.value.branch_name,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.branch_name) = $event)),
                    id: "branch_name",
                    name: "branch_name",
                    disabled: "",
                    label: "Branch",
                    placeholder: "Branch"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(TextInput, {
                    modelValue: form.value.booking_type,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.booking_type) = $event)),
                    id: "booking_type",
                    name: "booking_type",
                    disabled: "",
                    label: "Booking Type",
                    placeholder: "Booking Type"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(TextInput, {
                    modelValue: form.value.booking_status,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.booking_status) = $event)),
                    id: "booking_status",
                    name: "booking_status",
                    disabled: "",
                    label: "Booking Status",
                    placeholder: "Booking Status"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (canViewMedicalRecords.value)
                    ? (_openBlock(), _createBlock(TextInput, {
                        key: 0,
                        modelValue: form.value.remarks,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.remarks) = $event)),
                        id: "remarks",
                        name: "remarks",
                        textarea: "",
                        label: "Doctor Notes/Remarks",
                        placeholder: "Doctor Notes/Remarks"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                (canViewMedicalRecords.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(DropzoneInput, { label: "Medical Result/s" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["patient-id"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})